import React, { useEffect, useState } from 'react';
import { Card, Typography, Collapse, Divider, Row, Col, Empty, message, Popover } from "antd";
import moment from 'moment';
import PropTypes from 'prop-types';
import { useHistory } from "react-router-dom"
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { ExchangeCurrency, useExcryptedNavigation } from '../Filters/FilterConditions';
import Heading from '../../../components/heading/heading';
import { FetchSalesOrderByDeal } from "../../../Api/Services/SalesOrderApiService"
import { FetchQuotesByDeal } from "../../../Api/Services/QuotesApiService"
import { FetchInvoiceByDeal } from "../../../Api/Services/InvoiceApiServiec"
import { InvoiceIcon, QuotesIcon, SalesIcon } from '../../../components/Icons/Icons';

const { Text } = Typography;
const { Panel } = Collapse;

const LeadTable = ({ displayData, currencySettings, refreshTrigger, tabKey }) => {
    const history = useHistory();
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const [quoteData, setQuoteData] = useState()
    const [salesOrderData, setSalesOrderData] = useState()
    const [invoiceData, setInvoiceData] = useState()
    const [openPage1, setOpenPage1] = useState(Array(quoteData?.length).fill(false));
    const [openPage2, setOpenPage2] = useState(Array(salesOrderData?.length).fill(false));
    const [openPage3, setOpenPage3] = useState(Array(invoiceData?.length).fill(false));
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    async function getQuoteData(params) {
        try {
            const ConvertRates = currencySettings?.exchangeRate;
            const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
            const QuotesList = await FetchQuotesByDeal(params)
            const MergedQuotes = QuotesList.filter(item => item && item.data).map(item => ({
                ...item.data,
                allow: item.allow
            }));
            const SortedData = MergedQuotes.sort((a, b) => b.quotesId - a.quotesId);
            const dataWithCurrency = await Promise.all(
                SortedData.map(async item => {
                    const total = item.quotesItem?.grandTotalamount
                        ? await ExchangeCurrency(Number(item.quotesItem?.grandTotalamount), ConvertRates)
                        : item.quotesItem.grandTotalamount;
                    return {
                        ...item,
                        total_value: Number(total?.toFixed(CurencyDecimalPlace)),
                        DataPermission: { isPresent: item.allow }
                    };
                })
            );
            setQuoteData(dataWithCurrency)
        } catch (error) {
            message.error(error);
        }
    }
    async function getSalesOrderData(params) {
        try {
            const ConvertRates = currencySettings?.exchangeRate;
            const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
            const SalesOrderList = await FetchSalesOrderByDeal(params)
            const MergedQuotes = SalesOrderList.filter(item => item && item.data).map(item => ({
                ...item.data,
                allow: item.allow
            }));
            const SortedData = MergedQuotes.sort((a, b) => b.salesOrderId - a.salesOrderId);
            const dataWithCurrency = await Promise.all(
                SortedData.map(async item => {
                    const total = item.salesOrderItem?.grandTotalamount
                        ? await ExchangeCurrency(Number(item.salesOrderItem?.grandTotalamount), ConvertRates)
                        : item.salesOrderItem?.grandTotalamount;
                    return {
                        ...item,
                        total_value: Number(total?.toFixed(CurencyDecimalPlace)),
                        DataPermission: { isPresent: item.allow }
                    };
                })
            );
            setSalesOrderData(dataWithCurrency)
        } catch (error) {
            message.error(error);
        }
    }
    async function getInvoiceData(params) {
        try {
            const ConvertRates = currencySettings?.exchangeRate;
            const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
            const InvoiceList = await FetchInvoiceByDeal(params)
            const MergedQuotes = InvoiceList.filter(item => item && item.data).map(item => ({
                ...item.data,
                allow: item.allow
            }));
            const SortedData = MergedQuotes.sort((a, b) => b.invoiceId - a.invoiceId);
            const dataWithCurrency = await Promise.all(
                SortedData.map(async item => {
                    const total = item.invoiceItem?.grandTotalamount
                        ? await ExchangeCurrency(Number(item.invoiceItem?.grandTotalamount), ConvertRates)
                        : item.invoiceItem?.grandTotalamount;
                    return {
                        ...item,
                        total_value: Number(total?.toFixed(CurencyDecimalPlace)),
                        DataPermission: { isPresent: item.allow }
                    };
                })
            );
            setInvoiceData(dataWithCurrency)
        } catch (error) {
            message.error(error);
        }
    }
    useEffect(() => {
        if (displayData?.deals_id) {
            if (refreshTrigger === tabKey) {
                getQuoteData(displayData?.deals_id)
            }
        } else {
            setQuoteData([])
        }
    }, [displayData, refreshTrigger, tabKey])
    useEffect(() => {
        if (displayData?.deals_id) {
            if (refreshTrigger === tabKey) {
                getSalesOrderData(displayData?.deals_id)
            }
        }
        else {
            setSalesOrderData([])
        }
    }, [displayData, refreshTrigger, tabKey])
    useEffect(() => {
        if (displayData?.deals_id) {
            if (refreshTrigger === tabKey) {
                getInvoiceData(displayData?.deals_id)
            }
        }
        else {
            setInvoiceData([])
        }
    }, [displayData, refreshTrigger, tabKey])
    const isAllEmpty = displayData &&
        quoteData?.length === 0 &&
        salesOrderData?.length === 0 &&
        invoiceData?.length === 0;

    if (!displayData) return null; // handle null or undefined case
    const handleOpenPageChange1 = (index) => {
        const newPopoverOpenStates = [...openPage1];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpenPage1(newPopoverOpenStates);
    };
    const handleOpenPageChange2 = (index) => {
        const newPopoverOpenStates = [...openPage2];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpenPage2(newPopoverOpenStates);
    };
    const handleOpenPageChange3 = (index) => {
        const newPopoverOpenStates = [...openPage3];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpenPage3(newPopoverOpenStates);
    };
    return (
        <>
            {isAllEmpty ? (
                <div style={{ padding: "10%" }}>
                    <Empty />
                </div>
            ) : (
                <>
                    {quoteData?.length > 0 &&
                        <div style={{ marginBottom: 40 }}>
                            <div style={{ marginBottom: 20 }}>
                                <Heading as="h5" >Quotes</Heading>
                            </div>
                            {quoteData.map((item, index) => (
                                <div key={index} style={{ marginBottom: 15 }}>
                                    <Card className="DetailsTabCard">
                                        <Collapse bordered={false} className="DetailsTabCollapse">
                                            <Panel
                                                header={
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <QuotesIcon height={16} width={16} marginRight={5} />
                                                        <Text strong>{item.quotesName} ({item.quotesNumber})</Text>
                                                    </div>
                                                }
                                                key="1"
                                                extra={<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                    {item.DataPermission.isPresent &&
                                                        <Popover
                                                            placement="bottom"
                                                            content={
                                                                <div >
                                                                    <div className="text_icon newHover-class"
                                                                        role="button"
                                                                        tabIndex={0} title='View Details'
                                                                        onClick={() => {
                                                                            ViewDetailPage(item.quotesId, "QUOTES")
                                                                            handleOpenPageChange1(index)
                                                                        }}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                ViewDetailPage(item.quotesId, "QUOTES")
                                                                                handleOpenPageChange1(index)
                                                                            }
                                                                        }}
                                                                        aria-label='view'>
                                                                        <FeatherIcon icon="eye" size={16} style={{ marginRight: 5 }} /> View Details
                                                                    </div>
                                                                </div>
                                                            }
                                                            trigger="hover"
                                                            open={openPage1[index]}
                                                            onOpenChange={() => handleOpenPageChange1(index)}
                                                        >
                                                            <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                                                        </Popover>}
                                                </div>}
                                            >
                                                <Divider style={{ margin: 0 }} />
                                                <div style={{ marginTop: 10 }}>
                                                    <div >Status: <div className={`table_list_clicks status-text Qstatus${item.quotesStatus === "On Hold" ? "OnHold" : item.quotesStatus === "Closed Lost" ? "ClosedLost" : item.quotesStatus === "Closed Won" ? "ClosedWon" : item.quotesStatus}`}>{item.quotesStatus}</div></div>
                                                </div>
                                                <Divider style={{ margin: "10px 0" }} />
                                                <Row gutter={30}>
                                                    <Col span={6} style={{ borderRight: "1px solid #dddddd" }}>
                                                        <Text type="secondary" className='RightSide-Lable'>Issue Date</Text>
                                                        <br />
                                                        <Text>{item?.issueDate && profile.dateFormate ? moment(item?.issueDate).format(profile.dateFormate) : (item?.issueDate && moment(item?.issueDate).format("YYYY-MM-DD"))}
                                                        </Text>
                                                    </Col>
                                                    <Col span={6} style={{ borderRight: "1px solid #dddddd" }}>
                                                        <Text type="secondary" className='RightSide-Lable'>Expiry Date</Text>
                                                        <br />
                                                        <Text>{item?.validUntil && profile.dateFormate ? moment(item?.validUntil).format(profile.dateFormate) : (item?.validUntil && moment(item?.validUntil).format("YYYY-MM-DD"))}
                                                        </Text>
                                                    </Col>
                                                    <Col span={12}>
                                                        <Text type="secondary" className='RightSide-Lable'>Total</Text>
                                                        <br />
                                                        <Text>{currencySettings?.symbol} {item?.total_value?.toLocaleString()}
                                                        </Text>
                                                    </Col>
                                                </Row>
                                            </Panel>
                                        </Collapse>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    }
                    {salesOrderData?.length > 0 &&
                        <div style={{ marginBottom: 40 }}>
                            <div style={{ marginBottom: 20 }}>
                                <Heading as="h5">Tenancy Agreements</Heading>
                            </div>
                            {salesOrderData.map((item, index) => (
                                <div key={index} style={{ marginBottom: 15 }}>
                                    <Card className="DetailsTabCard">
                                        <Collapse bordered={false} className="DetailsTabCollapse">
                                            <Panel
                                                header={
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <SalesIcon Height={16} width={16} marginRight={5} />
                                                        <Text strong>{item.salesOrderName} ({item.salesOrderNumber})</Text>
                                                    </div>
                                                }
                                                key="1"
                                                extra={<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                    {item.DataPermission.isPresent &&
                                                        <Popover
                                                            placement="bottom"
                                                            content={
                                                                <div >
                                                                    <div className="text_icon newHover-class"
                                                                        role="button"
                                                                        tabIndex={0} title='View Details'
                                                                        onClick={() => {
                                                                            ViewDetailPage(item.salesOrderId, "SORDER")
                                                                            handleOpenPageChange2(index)
                                                                        }}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                ViewDetailPage(item.salesOrderId, "SORDER")
                                                                                handleOpenPageChange2(index)
                                                                            }
                                                                        }}
                                                                        aria-label='view'>
                                                                        <FeatherIcon icon="eye" size={16} style={{ marginRight: 5 }} /> View Details
                                                                    </div>
                                                                </div>
                                                            }
                                                            trigger="hover"
                                                            open={openPage2[index]}
                                                            onOpenChange={() => handleOpenPageChange2(index)}
                                                        >
                                                            <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                                                        </Popover>}
                                                </div>}
                                            >
                                                <Divider style={{ margin: 0 }} />
                                                <div style={{ marginTop: 10 }}>
                                                    <div >Status: <div className={`table_list_clicks status-text Qstatus${item.salesOrderStatus}`}>{item.salesOrderStatus}
                                                    </div></div>
                                                </div>
                                                <Divider style={{ margin: "10px 0" }} />
                                                <Row gutter={30}>
                                                    <Col span={8} style={{ borderRight: "1px solid #dddddd" }}>
                                                        <Text type="secondary" className='RightSide-Lable'>Quote No</Text>
                                                        <br />
                                                        <Text>{item?.quotesNumber}
                                                        </Text>
                                                    </Col>
                                                    <Col span={6} style={{ borderRight: "1px solid #dddddd" }}>
                                                        <Text type="secondary" className='RightSide-Lable'>Due Date</Text>
                                                        <br />
                                                        <Text>{item?.dueDate && profile.dateFormate ? moment(item?.dueDate).format(profile.dateFormate) : (item?.dueDate && moment(item?.dueDate).format("YYYY-MM-DD"))}
                                                        </Text>
                                                    </Col>
                                                    <Col span={10}>
                                                        <Text type="secondary" className='RightSide-Lable'>Total</Text>
                                                        <br />
                                                        <Text>{currencySettings?.symbol} {item?.total_value?.toLocaleString()}
                                                        </Text>
                                                    </Col>
                                                </Row>
                                            </Panel>
                                        </Collapse>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    }
                    {invoiceData?.length > 0 &&
                        <div style={{ marginBottom: 40 }}>
                            <div style={{ marginBottom: 20 }}>
                                <Heading as="h5" >Invoices</Heading>
                            </div>
                            {invoiceData.map((item, index) => (
                                <div key={index} style={{ marginBottom: 15 }}>
                                    <Card className="DetailsTabCard">
                                        <Collapse bordered={false} className="DetailsTabCollapse">
                                            <Panel
                                                header={
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <InvoiceIcon Height={16} width={16} marginRight={5} />
                                                        <Text strong>{item.invoiceName} ({item.invoiceNumber})</Text>
                                                    </div>
                                                }
                                                key="1"
                                                extra={<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                    {item.DataPermission.isPresent &&
                                                        <Popover
                                                            placement="bottom"
                                                            content={
                                                                <div >
                                                                    <div className="text_icon newHover-class"
                                                                        role="button"
                                                                        tabIndex={0} title='View Details'
                                                                        onClick={() => {
                                                                            ViewDetailPage(item.invoiceId, "INVOICE")
                                                                            handleOpenPageChange3(index)
                                                                        }}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                ViewDetailPage(item.invoiceId, "INVOICE")
                                                                                handleOpenPageChange3(index)
                                                                            }
                                                                        }}
                                                                        aria-label='view'>
                                                                        <FeatherIcon icon="eye" size={16} style={{ marginRight: 5 }} /> View Details
                                                                    </div>
                                                                </div>
                                                            }
                                                            trigger="hover"
                                                            open={openPage3[index]}
                                                            onOpenChange={() => handleOpenPageChange3(index)}
                                                        >
                                                            <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                                                        </Popover>}
                                                </div>}
                                            >
                                                <Divider style={{ margin: 0 }} />
                                                <div style={{ marginTop: 10 }}>
                                                    <div >Status: <div className={`table_list_clicks status-text Qstatus${item.invoiceStatus}`}>{item.invoiceStatus}
                                                    </div></div>
                                                </div>
                                                <div style={{ marginTop: 10, display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
                                                    <div>Tenancy Agreement No: {item?.salesOrderNumber}</div>
                                                    <div>Quote No: {item?.quotesNumber}</div>
                                                </div>
                                                <Divider style={{ margin: "10px 0" }} />
                                                <Row gutter={30}>
                                                    <Col span={6} style={{ borderRight: "1px solid #dddddd" }}>
                                                        <Text type="secondary" className='RightSide-Lable'>Invoice Date</Text>
                                                        <br />
                                                        <Text>{item?.invoiceDate && profile.dateFormate ? moment(item?.invoiceDate).format(profile.dateFormate) : (item?.invoiceDate && moment(item?.invoiceDate).format("YYYY-MM-DD"))}
                                                        </Text>
                                                    </Col>
                                                    <Col span={6} style={{ borderRight: "1px solid #dddddd" }}>
                                                        <Text type="secondary" className='RightSide-Lable'>Due Date</Text>
                                                        <br />
                                                        <Text>{item?.dueDate && profile.dateFormate ? moment(item?.dueDate).format(profile.dateFormate) : (item?.dueDate && moment(item?.dueDate).format("YYYY-MM-DD"))}
                                                        </Text>
                                                    </Col>
                                                    <Col span={10}>
                                                        <Text type="secondary" className='RightSide-Lable'>Total</Text>
                                                        <br />
                                                        <Text>{currencySettings?.symbol} {item?.total_value?.toLocaleString()}
                                                        </Text>
                                                    </Col>
                                                </Row>
                                            </Panel>
                                        </Collapse>
                                    </Card>
                                </div>
                            ))}
                        </div >
                    }
                </>
            )
            }
        </>
    )
}
LeadTable.propTypes = {
    currencySettings: PropTypes.array.isRequired,
    displayData: PropTypes.object.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(LeadTable)